import { __awaiter } from "tslib";
import { InterconsultService } from "@/servicesTs/models/interconsult/interconsult";
import { ScheduleCitationService } from "@/services/models/schedule/scheduleCitation";
const moduleSideMenu = {
    namespaced: true,
    state: {
        cantInterconsultPendings: 0,
        cantInterconsultPendingsLoading: false,
        cantScheduleCitationPending: 0,
        cantScheduleCitationPendingLoading: false,
    },
    getters: {
        getCantInterconsultPendings(state) {
            return state.cantInterconsultPendings;
        },
        getCantInterconsultPendingsLoading(state) {
            return state.cantInterconsultPendingsLoading;
        },
        getCantScheduleCitationPending(state) {
            return state.cantScheduleCitationPending;
        },
        getCantScheduleCitationPendingLoading(state) {
            return state.cantScheduleCitationPendingLoading;
        },
    },
    mutations: {
        loadCantInterconsultPendings(state, cantInterconsultPendings) {
            state.cantInterconsultPendings = cantInterconsultPendings;
        },
        setCantInterconsultPendingsLoading(state, cantInterconsultPendingsLoading) {
            state.cantInterconsultPendingsLoading = cantInterconsultPendingsLoading;
        },
        loadCantScheduleCitationPending(state, cantScheduleCitationPending) {
            state.cantScheduleCitationPending = cantScheduleCitationPending;
        },
        setCantScheduleCitationPendingLoading(state, cantScheduleCitationPendingLoading) {
            state.cantScheduleCitationPendingLoading = cantScheduleCitationPendingLoading;
        },
    },
    actions: {
        loadCantInterconsultPendings({ commit }, filter) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    commit("setCantInterconsultPendingsLoading", true);
                    commit("loadCantInterconsultPendings", 0);
                    const count = yield InterconsultService.countInterconsultFilter(filter);
                    commit("loadCantInterconsultPendings", count.data.interconsults);
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    commit("setCantInterconsultPendingsLoading", false);
                }
            });
        },
        loadCantScheduleCitationPending({ commit }, filter) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    commit("setCantScheduleCitationPendingLoading", true);
                    commit("loadCantScheduleCitationPending", 0);
                    const count = yield ScheduleCitationService.countScheduleCitationPending(filter);
                    commit("loadCantScheduleCitationPending", count.schedule_citations);
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    commit("setCantScheduleCitationPendingLoading", false);
                }
            });
        },
    },
};
export default moduleSideMenu;
